module.exports = __webpack_public_path__ + "img/sec_06.a8891a93.png";